import {GlobalAppConfig} from '../environment/global-app-config';
import {Uuid} from '../../domain/uuid';
import * as crypto from 'crypto-js';
import * as moment from 'moment';

export class EnvironmentService {
  languageCodeSweden = 'sv';
  languageCodeNorway = 'no';
  private _referrer = '';

  constructor(private globalAppConfig: GlobalAppConfig) {
  }

  public get apiToken() {
    const ts = `${moment().unix()}`;
    const data = `${ts}:gsJ75nW6wgBQhp5AOl6b`;
    return `${ts}:${crypto.SHA256(data).toString()}`;
  }

  public get isLocal(): boolean {
    return this.globalAppConfig.envLabel === 'LOCAL';
  }

  public get label(): string {
    return this.globalAppConfig.envLabel;
  }

  public get themeCss(): string {
    return this.globalAppConfig.themeCss;
  }

  public get languageCode(): string {
    if (this.isNorway) {
      return this.languageCodeNorway;
    }
    return this.languageCodeSweden;
  }

  public get countryCode(): string {
    if (!this.globalAppConfig.countryCode) {
      return 'se';
    }
    return this.globalAppConfig.countryCode;
  }

  public get isNorway(): boolean {
    return this.countryCode === 'no';
  }

  public get apiEndpoint(): string {
    return this.globalAppConfig.apiEndpoint;
  }

  public get apiCalendarEndpoint(): string {
    return this.globalAppConfig.apiCalendarEndpoint;
  }

  public getJtpBookingUrl(uuid: Uuid): string {
    let baseUrl = `${this.getWebbookingEndpoint}`;
    if (this.referrer) {
      baseUrl = `${this.referrer}`;
    }
    if (!baseUrl.endsWith('/')) {
      baseUrl = baseUrl + '/';
    }
    return `${baseUrl}${this.globalAppConfig.jtpSuffix}/${uuid}`;
  }

  public get getWebbookingEndpoint(): string {
    return `${this.globalAppConfig.webBookingEndpoint}`;
  }

  public get workshopSearchEndpoint(): string {
    return this.globalAppConfig.workshopSearchEndpoint;
  }

  public get jwtToken(): string {
    return this.globalAppConfig.apiCalendarJwt;
  }

  public get assetsUrl(): string {
    return this.globalAppConfig.assetsUrl || './assets';
  }

  public get isBeta(): boolean {
    return this.globalAppConfig.isBeta;
  }

  public set referrer(referrer: string) {
    this._referrer = '';
    const allowedReferrers = this.globalAppConfig.allowedReferrers;
    if (!referrer || !allowedReferrers) {
      return;
    }
    if (allowedReferrers.find(r => referrer.startsWith(r))) {
      const i = referrer.indexOf('#');
      if (i > 0) {
        referrer = referrer.substr(0, i);
      }
      this._referrer = referrer;
    }
  }

  public get referrer() {
    return this._referrer;
  }
}
